var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"detail"}},[_c('img',{attrs:{"src":"https://zj-web-source.oss-cn-beijing.aliyuncs.com/wxmini/imgs/mp_content_detail.jpg"}})])
}]

export { render, staticRenderFns }